import {
	LD_JSON_HOMEPAGE_CORPORATION_METADATA,
	LD_JSON_HOMEPAGE_WEBSITE_METADATA,
} from '@/components/blocks/MetadataScript/constants';

export const getHomepageMetaData = () => [
	LD_JSON_HOMEPAGE_WEBSITE_METADATA,
	LD_JSON_HOMEPAGE_CORPORATION_METADATA,
];
